import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ResetPasswordFormValues } from '../common/interfaces';
import { ResetPasswordView } from './resetPasswordView';
import { resetPassword } from '../data/endpointServices';
import { antiForgeryFormOptions } from '../common/antiForgery';
import { routes } from '../common/routes';

export const ResetPasswordPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState<string>('');

    const antiforgeryOptions = antiForgeryFormOptions();
    const { errors: fieldsErrors, handleSubmit, register } = useForm();

    const submitResetPassword = async(data: ResetPasswordFormValues) => {
        setLoading(true);

        try {
            if (data) {
                const response = await resetPassword(data?.email, antiforgeryOptions);
                if (response ) {
                    window.location.href = routes?.resetpasswordmessage;
                }
            }
        } catch (error ) {
            if (error?.response?.data?.c === 400) {
                setServerError(t('emailErrorMessage'));
            } else {
                setServerError(t('cannotProcessPasswordRecovery'));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <ResetPasswordView 
            submitResetPassword={submitResetPassword}
            fieldsErrors={fieldsErrors}
            handleSubmit={handleSubmit}
            register={register}
            loading={loading}
            serverError={serverError}
        />
    );
};

